import React from 'react';

import logo from './logo.svg';
import './App.css';
import CustomNavBar from './Components/navbar';
import Home from './Components/home'
import Feature from './Components/feature'
import Contact from './Components/contact'
import {
  HashRouter,
  BrowserRouter as Router,
  Switch,
  Route,
  Link
 
} from "react-router-dom";
import { } from 'reactstrap';


const App = (props) => {
  

  return (
    
    <HashRouter >
    <div >
      <CustomNavBar/>
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/Home" component={Home}/>
      
        <Route exact path="/Feature" component={Feature}/>
        <Route exact path="/Contact" component={Contact}/>
         
       
       {/*  <Route path="/contact" component={Contact}/> */}
      </Switch>
    </div>
    </HashRouter>
  );
}

export default App;